// action - state management
import { LOGIN, LOGOUT, REGISTER, UPDATE_PROFILE } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  roles: null,
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user,
      };
    }
    case LOGIN: {
      const { user, roles } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        roles,
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        roles: null,
      };
    }
    case UPDATE_PROFILE: {
      const { user } = action.payload;
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: true,
        user,
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default accountReducer;
